import { Route, Routes } from 'react-router-dom';
import {
  PUBLIC_ROUTER_SIGNATURES,
  PRIVATE_ROUTER_SIGNATURES,
} from './router/router';

export function PublicSignaturePages() {
  return (
    <Routes>
      {PUBLIC_ROUTER_SIGNATURES.map((route) => (
        <Route key={route.path} path={route.path} element={route.component} />
      ))}
    </Routes>
  );
}

export function PrivateSignaturesPages() {
  return (
    <Routes>
      {PRIVATE_ROUTER_SIGNATURES.map((route) => (
        <Route key={route.path} path={route.path} element={route.component} />
      ))}
    </Routes>
  );
}
